import { graphql } from "@opensea/graphql"

export const ChainChipFragment = graphql(`
  fragment ChainChip on Chain {
    identifier
    name
  }
`)
